export default {
  savedAll: [],
  savedByKeywords: [],
  saved: {},
  cleanSavedPost: false,
  active: false,
  isLoading: false
};
